/* Sinneszauber – Produktbewertungen mit Judge.me (17.10.2026)
   Judge.me laedt im Shop ueber die App-Einbettung (config/settings_data.json). Sein Lader sucht nur
   einmal beim Seitenaufbau nach Bewertungsfeldern. Da die Produktseiten hier erst danach entstehen,
   setzt SZReviews.mount() das Feld selbst ein und startet das Judge.me-Widget bei jedem Produkt neu.
   - Bewertung schreiben nur fuer Kaeufer: angemeldet (window.SZ_LOGGEDIN) UND das Produkt steckt in einer
     eigenen, nicht stornierten Bestellung (window.SZ_BOUGHT = ",id,id," aus Liquid). Gaeste sehen einen
     Login-Link, angemeldete Nicht-Kaeufer einen Hinweis. Der Knopf erscheint nur mit .is-buyer (17.10.2026)
   - lokal (ohne Shopify) wird der Bereich ausgeblendet */
(function () {
  const ids = {};
  let cssDone = false;

  const live = () => !!(window.SZ && SZ.live);
  const ready = () => window.jdgm && jdgm.CDN_BASE_URL && jdgm._loaderExecuted;
  const waitReady = (ms = 10000) => new Promise((res) => {
    const t0 = Date.now();
    (function tick() {
      if (ready()) return res(true);
      if (Date.now() - t0 > ms) return res(false);
      setTimeout(tick, 150);
    })();
  });

  async function productId(handle) {
    if (ids[handle]) return ids[handle];
    const r = await fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}products/${encodeURIComponent(handle)}.js`);
    if (!r.ok) throw new Error('Produkt nicht gefunden');
    const j = await r.json();
    return (ids[handle] = j.id);
  }

  // Stylesheets des Widgets wie im Judge.me-Lader (manifest.json)
  async function loadCss() {
    if (cssDone) return;
    cssDone = true;
    const base = jdgm.CDN_BASE_URL;
    const add = (c) => {
      const href = base + c;
      if (document.querySelector(`link[href="${href}"]`)) return;
      const l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      document.head.appendChild(l);
    };
    try {
      const man = await (await fetch(base + 'manifest.json')).json();
      const walk = (k, seen = new Set()) => {
        const m = man[k];
        if (!m || seen.has(k)) return;
        seen.add(k);
        (m.css || []).forEach(add);
        (m.imports || []).forEach((i) => walk(i, seen));
      };
      walk('review-widget/main.js');
    } catch (_) {}
  }

  // Judge.me-Grundprogramme (jQuery-Basis, Formular, Schreib-Fenster). Der Lader holt sie nur, wenn beim
  // Seitenaufbau schon ein Bewertungsfeld da ist. Ohne sie bleibt "Bewertung schreiben" ohne Wirkung (17.10.2026)
  let core = null;
  function loadCore() {
    if (core) return core;
    core = new Promise((res) => {
      const done = () => { if (window.jdgm && jdgm.$ && jdgm._WriteReviewModal) res(true); };
      jdgm.loadScript('widget/base.js', () => {
        jdgm.loadScript('widget/common.js', () => {
          jdgm.loadCSS(jdgm.widgetPath('form.css'));
          jdgm.loadScript(jdgm.CDN_HOST + 'widget/form.js');
          jdgm.loadScript(jdgm.CDN_HOST + 'widget/write_review_modal.js');
          const t0 = Date.now();
          (function wait() { done(); if (Date.now() - t0 < 8000) setTimeout(wait, 150); else res(false); })();
        });
      });
      setTimeout(() => res(false), 12000);
    });
    return core;
  }

  // Widget-Modul neu ausfuehren (anderer URL-Parameter = neues Modul), damit es das neue Feld findet
  function boot() {
    const s = document.createElement('script');
    s.type = 'module';
    s.src = jdgm.CDN_BASE_URL + 'review_widget.js?sz=' + Date.now();
    s.className = 'sz-jdgm-boot';
    document.head.appendChild(s);
  }

  async function mount(box, handle, title) {
    if (!box) return;
    if (!live()) { box.hidden = true; return; }
    const guest = !window.SZ_LOGGEDIN;
    box.classList.remove('is-buyer', 'is-nobuyer');
    box.classList.toggle('is-guest', guest);
    const login = box.querySelector('[data-sz-login]');
    if (login) login.href = '/account/login?return_url=' + encodeURIComponent('/products/' + handle);
    const note = box.querySelector('[data-sz-check]');
    if (note && window.jdgmSettings && jdgmSettings.autopublish === false) note.textContent += ' Jede Bewertung wird vor der Veröffentlichung von uns geprüft.';
    if (!(await waitReady())) { box.hidden = true; return; }
    let pid;
    try { pid = await productId(handle); } catch (_) { box.hidden = true; return; }
    if (!box.isConnected) return; // Seite wurde inzwischen gewechselt
    if (!guest) {
      const buyer = String(window.SZ_BOUGHT || ',').indexOf(',' + pid + ',') !== -1;
      box.classList.add(buyer ? 'is-buyer' : 'is-nobuyer');
    }
    const el = document.createElement('div');
    el.id = 'judgeme_product_reviews';
    el.className = 'jdgm-widget jdgm-review-widget';
    Object.assign(el.dataset, {
      productTitle: title, id: String(pid), productId: String(pid), widget: 'review', autoInstall: 'false',
      entryPoint: 'review_widget.js', entryKey: 'review-widget/main.js', shopReviews: 'true',
    });
    // angemeldeter Kunde: Judge.me fuellt Name und E-Mail im Formular vor
    const c = window.SZ_CUSTOMER;
    if (c && c.id && c.email) Object.assign(el.dataset, { customerId: String(c.id), customerEmail: c.email, customerFirstName: c.firstName || '', customerLastName: c.lastName || '', customerName: c.name || '' });
    const slot = box.querySelector('[data-sz-widget]');
    slot.innerHTML = '';
    slot.appendChild(el);
    await loadCss();
    await loadCore();
    if (!box.isConnected) return;
    boot();
  }

  window.SZReviews = { mount };
})();
